const defaultConfigName = 'global-production';//（正式环境）
// const defaultConfigName = 'global-test';//（测试环境）
module.exports = defaultConfigName;
